import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../../../lib/api';
import { FiLock, FiEye, FiEyeOff, FiKey } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const navigate = useNavigate();
  
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword!== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const res = await api.resetPassword(email, otp, newPassword);
      if (res.success) {
        toast.success('Password reset successful!');
        navigate('/login');
      } else {
        toast.error(res.message || 'Invalid OTP or failed to reset');
      }
    } catch (error) {
      toast.error('Something went wrong');
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
       .auth-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #667EEA 0%, #764BA2 100%); padding: 20px; }
       .auth-card { background: rgba(255,255,255,0.95); backdrop-filter: blur(20px); border-radius: 24px; padding: 50px 40px; width: 100%; max-width: 420px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
       .auth-title { font-size: 28px; font-weight: 800; color: #0F172A; margin: 0 0 8px 0; text-align: center; }
       .auth-subtitle { color: #64748B; font-size: 15px; text-align: center; margin-bottom: 30px; }
       .form-group { margin-bottom: 20px; }
       .input-wrapper { position: relative; }
       .input-icon { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #94A3B8; font-size: 18px; }
       .form-input { width: 100%; padding: 14px 16px 14px 48px; border: 2px solid #E2E8F0; border-radius: 12px; font-size: 15px; box-sizing: border-box; }
       .form-input:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1); }
       .password-toggle { position: absolute; right: 16px; top: 50%; transform: translateY(-50%); background: none; border: none; color: #94A3B8; cursor: pointer; font-size: 18px; }
       .auth-btn { width: 100%; padding: 14px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #FFF; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; }
       .auth-btn:disabled { opacity: 0.6; cursor: not-allowed; }
      `}</style>
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Reset Password</h1>
          <p className="auth-subtitle">Enter OTP sent to {email}</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-wrapper">
                <FiKey className="input-icon" />
                <input type="text" className="form-input" placeholder="Enter 6-digit OTP" value={otp} onChange={(e) => setOtp(e.target.value)} maxLength={6} required />
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input type={showPassword? 'text' : 'password'} className="form-input" placeholder="New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input type={showPassword? 'text' : 'password'} className="form-input" placeholder="Confirm New Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
              </div>
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
export default ResetPassword;